export enum BadgeStatus {
  Success = 'success',
  Processing = 'processing',
  Error = 'error',
  Warning = 'warning'
}
